import { ImageService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import * as IDavis from '@DavisDigital/interfaces';

class CompareImagesModalController {

	public firstImage;
	public secondImage;
	
	public hasDetails = true; 
	
	public showDetails = true;

	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

	// @ngInject
	constructor(
		public ModalService,
		public $element,
		public $window,
		public $q				: ng.IQService,
		public $scope			: ng.IScope,
		public imageService		: ImageService,
		public observerService	: ObserverService,
		public $timeout			: ng.ITimeoutService
	){}
	
	public $onInit = () => {
		this.hasDetails = this.firstImage.imageName != null ||
						  this.firstImage.artistName != null || 
						  this.secondImage.imageName != null ||
						  this.secondImage.artistName != null;

		// Focus is returned to the Compare and Contrast button by
		// imageController.handleCompareAndContrast() once the dialog closes (WCAG 2.4.3).
		// It can't be captured here: angular-modal-service has already blurred it.

		// Set initial focus to the modal's close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		// Trap focus within the modal
		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	public close = () => {
		let result = {
			event: null,
			message: 'Modal closed.'
		};
		this.ModalService.closeModals(result);
	}

	public closeAllModals = (event:any):this => {
		let result = {
			event: event,
			message: 'All modals have been closed.'
		};

		this.ModalService.closeModals(result);
		return this;
	}
	
	public toggleDetails = () =>{
		this.showDetails = !this.showDetails;
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			// Shift+Tab: if focus is on first element, wrap to last
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			// Tab: if focus is on last element, wrap to first
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}
}

export class CompareImagesModal {
	public restrict: string = 'E';
	public scope: boolean = true;
	public controller: any = CompareImagesModalController;
	public controllerAs: string = 'compareImagesModal';
	public templateUrl: string = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/compare-images-modal.html';
	public bindToController: any = {
		firstImage: '=',
		secondImage: '='
	};

	public static Factory() {
		return () => new this();
	}
}
